// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Zwf-Q","newExpiryDate":"styles_newExpiryDate__2MQ7c","footer":"styles_footer__3C4_p"};